import axios from "axios";
import { operatorSlice } from "../reducers/OperatorSlice";
import { AppDispatch } from "../Store";
import { GET_ME_URL, LOGIN_URL, LOGOUT_URL, OPERATOR_URL } from "./endpoints";
import { ICreateOperator } from "../types/OperatorTypes";
import { POST_IMAGE_URL, POST_IMAGE_WIDGET_URL } from "./endpoints";

export const login =
  (login: string, password: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(operatorSlice.actions.loginLoading());
      const res = await axios.post(
        LOGIN_URL,
        {
          login: login,
          password: password,
        },
        { withCredentials: true },
      );
      dispatch(operatorSlice.actions.loginSuccess(res.data));
    } catch (error: any) {
      dispatch(operatorSlice.actions.loginFailed(error.message));
    }
  };

export const me = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(operatorSlice.actions.operatorFetching());
    const res = await axios.get(GET_ME_URL, { withCredentials: true });
    dispatch(operatorSlice.actions.operatorFetchSuccess(res.data));
  } catch (error: any) {
    dispatch(operatorSlice.actions.operatorFetchFailed(""));
  }
};

export const logout = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(operatorSlice.actions.logoutLoading());
    await axios.post(LOGOUT_URL, {}, { withCredentials: true });
    dispatch(operatorSlice.actions.logoutSuccess());
  } catch (error: any) {
    dispatch(operatorSlice.actions.logoutFailed(error.message));
  }
};

export const addOperator =
  (operator: ICreateOperator) =>
  async (dispatch: AppDispatch): Promise<Boolean> => {
    try {
      dispatch(operatorSlice.actions.addOperatorLoading());
      const res = await axios.post(
        OPERATOR_URL,
        {
          login: operator.login,
          name: operator.name,
          password: operator.password,
          project: operator.project,
          role: operator.role,
        },
        { withCredentials: true },
      );
      dispatch(operatorSlice.actions.addOperatorSuccess(res.data));
      return true;
    } catch (error: any) {
      dispatch(operatorSlice.actions.addOperatorFailed(error.message));
      return false;
    }
  };

export const removeOperator = (id: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(operatorSlice.actions.deleteOperatorLoading());
    const res = await axios.delete(OPERATOR_URL + `?id=${id}`, {
      withCredentials: true,
    });
    dispatch(operatorSlice.actions.deleteOperatorSuccess(res.data));
    return true;
  } catch (error: any) {
    dispatch(operatorSlice.actions.deleteOperatorFailed(error.message));
    return false;
  }
};

export const getAllOperators = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(operatorSlice.actions.getOperatorsLoading());
    const res = await axios.get(OPERATOR_URL, { withCredentials: true });
    dispatch(operatorSlice.actions.getOperatorsSuccess(res.data));
  } catch (error: any) {
    dispatch(operatorSlice.actions.getOperatorsFailed(error.message));
  }
};

export const editOperator =
  (oepratorId: string, data: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch(operatorSlice.actions.updateOperatorLoading());

      const res = await axios.patch(OPERATOR_URL + `?id=${oepratorId}`, data, {
        withCredentials: true,
      });
      dispatch(operatorSlice.actions.updateOperatorSuccess(res.data));
      return true;
    } catch (error: any) {
      dispatch(operatorSlice.actions.updateOperatorFailed(error.message));
      return false;
    }
  };

export const sendPhotoToTelegram =
  (
    chatId: string,
    ticketId: number,
    file: File,
    caption = "",
    operatorId?: string,
  ) =>
  async () => {
    const form = new FormData();
    form.append("chatId", chatId);
    form.append("ticketId", String(ticketId));
    form.append("caption", caption);
    if (operatorId) form.append("operatorId", operatorId);
    form.append("photo", file);

    await axios.post(POST_IMAGE_URL, form, { withCredentials: true });
    return true;
  };

export const sendPhotoToWidget =
  (ticketId: number, file: File, caption = "") =>
  async () => {
    const form = new FormData();
    form.append("ticketId", String(ticketId));
    form.append("caption", caption);
    form.append("photo", file);

    await axios.post(POST_IMAGE_WIDGET_URL, form, { withCredentials: true });
    return true;
  };
